export { default as AccountPhoto } from './AccountPhoto';
